/// <reference path="../../../WebUI/typings/tsd.d.ts" />

import * as React from "react";
import * as ReactDOM from "react-dom";
import {DialogBase} from "./DialogBase";
import * as Views from "../Views/MessageBox";
import {resourceStrings} from "../../../Intercom.ReactUI/Views/Strings";

export class MessageBox extends DialogBase {
    public header: string;
    public message: string;
    private options: IMessageBoxOptions;

    constructor(options: IMessageBoxOptions) {
        super();
        this.options = $.extend({}, DefaultMessageBoxOptions, options);
    }

    protected render(): void {
        var props: Views.MessageBoxPanelProps = {
            okButtonClass: this.options.okButtonClass,
            okButtonLabel: this.options.okButtonLabel,
            cancelButtonLabel: this.options.cancelButtonLabel,
            hideCancelButton: this.options.hideCancelButton,
            message: this.message,
            header: this.header,
            className: this.options.className
        };
        var element = React.createElement(Views.MessageBoxPanel, props);
        ReactDOM.render(element, this.$el[0], () => {
            this.init();
        });
    }

    protected init(): void {
        // Call base class method to complete initialization.
        super.init();
    }

    /** Static method for displaying a simple message. */
    public static show(message: string): JQueryPromise<any> {
        var mb = new MessageBox({ hideCancelButton: true });
        mb.message = message;
        return mb.showDialog();
    }

    /** Static method for asking the user a yes/no question. OK/Cancel buttons are relabeled to Yes/No. */
    public static ask(message: string): JQueryPromise<any> {
        var mb = new MessageBox({ okButtonLabel: resourceStrings.buttonYes, cancelButtonLabel: resourceStrings.buttonNo });
        mb.message = message;
        return mb.showDialog();
    }

}

export interface IMessageBoxOptions {
    className?: string;
    hideCancelButton?: boolean;
    okButtonClass?: string;
    okButtonLabel?: string;
    cancelButtonLabel?: string;
}

var DefaultMessageBoxOptions: IMessageBoxOptions = {
    hideCancelButton: false,
    okButtonLabel: resourceStrings.buttonOk,
    cancelButtonLabel: resourceStrings.buttonCancel
};




// WEBPACK FOOTER //
// ./Client/Dialogs/MessageBox.ts